<template>
  <v-app v-if="$route.meta.anonymousAuth && [' /'].indexOf(this.$route.path) < 0">
    <IndexLayout />
    <ModalValidacaoHandler />
  </v-app>

  <v-app v-else-if="isLoginPadrao && !isLoginToken">
    <Toolbar>
      <template slot="toolbar-avatar">
        <v-avatar
          style="cursor: pointer"
          @click="gotoHome"
          max-height="40px"
          size="80"
          class="ml-3"
          tile
        >
          <ImagemComFallback
            :src="avatar"
            srcDefault="/assets/imgs/logo.svg"
            width="100%"
            height="100%"
            contain
            data-cy="toolbar-img"
          />
        </v-avatar>
      </template>

      <template slot="toolbar-title"> &nbsp; </template>
      <template slot="toolbar-drawer"> &nbsp; </template>

      <template slot="toolbar-after-spacer">
        <div class="ml-auto mr-0" v-if="portalBloqueado">
          <v-tooltip bottom max-width="300">
            <template v-slot:activator="{ on }">
              <v-chip color="warning" v-on="on">
                <v-icon small class="mr-2">ph-warning</v-icon>
                Portal Bloqueado
              </v-chip>
            </template>
            <span data-cy="tooltip-text"
              >Não é possível realizar inclusões e alterações de dados!</span
            >
          </v-tooltip>
        </div>
      </template>
    </Toolbar>

    <v-main>
      <v-container
        id="layout-main-container"
        fluid
        style="height: 100%"
        class="pa-0 ma-0 layout-main-container"
      >
        <router-view></router-view>
      </v-container>
    </v-main>
    <ModalValidacaoHandler />
  </v-app>

  <v-app v-else>
    <v-main>
      <v-container
        id="layout-main-container"
        class="pa-0 ma-0 layout-main-container"
        fluid
        style="height: 100%"
      >
        <router-view></router-view>
      </v-container>
    </v-main>
    <ModalValidacaoHandler />
  </v-app>
</template>

<style lang="sass">
@import 'assets/styles/styles.scss'

$white-color: #FFF
.layout-main-container
  &-white
    background-color: $white-color
</style>

<script>

export default {
  data () {
    return {
      isLoginPadrao: false,
      isLoginToken: false,
      tempoRestanteSessao: '',
      tempo: 0,
      user: null,
      avatar: this.$theme.logoHome
    }
  },
  components: {
    IndexLayout: () => import('@bmp-vue/core/layouts/IndexLayout'),
    Toolbar: () => import('./OnboardingToolbar.vue'),
    ModalValidacaoHandler: () => import('../views/Modais/ModalValidacaoHandler.vue'),
  },
  methods: {
    gotoHome () {
      this.$router.goToHome(this.$route.path)
    },
    startInactiveTimer () {
      const th = this
      let timeout
      const tempoInatividade = 3 * 60 * 1000
      function reiniciarTimeout () {
        clearTimeout(timeout)
        timeout = setTimeout(() => {
          th.inactivateSession()
        }, tempoInatividade)
      }
      window.addEventListener('keydown', reiniciarTimeout)
      window.addEventListener('mousemove', reiniciarTimeout)

      reiniciarTimeout()
    },
    inactivateSession () {
      const targetWindow =
        window.parent ?? window.top ?? window.opener ?? window
      targetWindow.postMessage('multiplo.mouseInativo', '*')
      localStorage.clear()
      localStorage.setItem('status', 'loggedOut')
      localStorage.setItem('logoutReason', 'mouseInactivity')
    },
    handleSessionTime () {
      this.setExpirationTime()
      if (this.tempo > 0) this.startCountdown()
    },
    startCountdown () {
      const th = this
      const isLogged = th.setExpirationTime()

      if (th.tempo > 9) {
        let min = parseInt(th.tempo / 60)
        let seg = th.tempo % 60

        if (min < 10) {
          min = '0' + min
          min = min.substr(0, 2)
        }
        if (seg <= 9) seg = '0' + seg

        th.tempoRestanteSessao = min + ':' + seg

        if (isLogged) {
          setTimeout(function () {
            th.startCountdown()
          }, 1000)
        }
      } else {
        th.$api.UI.Confirmacao(
          'info',
          'Deseja renovar a sessão?',
          th.refreshToken,
          th.logout,
          'Sessão expirada'
        )
      }
    },
    setExpirationTime () {
      const th = this
      const status = localStorage.getItem('status')
      const logoutReason = localStorage.getItem('logoutReason')
      this.user = this.$store.getters.user
      if (status) {
        if (status === 'loggedIn') {
          while (!this.user) {
            this.user = JSON.parse(localStorage.getItem('user'))
          }

          const dataExpiracao = new Date(this.user.expiresAt)
          const dataAtual = new Date()
          this.tempo = Math.trunc(
            (dataExpiracao.getTime() - dataAtual.getTime()) / 1000
          )
        } else if (logoutReason === 'mouseInactivity') {
          return false
        } else {
          th.$api.UI.Confirmacao(
            'info',
            'Deseja renovar a sessão?',
            th.refreshToken,
            th.logout,
            'Sessão expirada'
          )
          return false
        }
      }
      return true
    },
    logout () {
      const th = this
      th.$api.Autenticacao.Logout()
        .then(function (data) {
          if (th.$api.UI.PostLoadData(data)) {
            const targetWindow =
              window.parent ?? window.top ?? window.opener ?? window
            targetWindow.postMessage('multiplo.recusaRefresh', '*')
            localStorage.clear()
            localStorage.setItem('status', 'loggedOut')
          }
        })
        .catch((err) => console.log(err))
    },
    handleRefreshSuccess (responseAuth) {
      const th = this
      responseAuth.roles = th.GetUserTokenRole(responseAuth.accessToken)
      const user = th.$api.UTIL.Auth.RegisterToken(
        responseAuth,
        th.user.identificador
      )

      if (user) {
        user.documento = th.$api.UI.Format.DocumentoFederal(
          responseAuth.dadosIntegracao.operador.documentoFederal
        )
        th.$store.dispatch('setUserData', { user })

        if (
          th.$empresa &&
          th.$empresa.codigo !== responseAuth.empresas[0].codigo
        ) {
          th.$api.Empresa.GetByIdToParceiroSemLoading(
            responseAuth.empresas[0].codigo
          )
            .then(function (empresa) {
              if (th.$api.UI.PostLoadData(empresa)) {
                empresa.codigoParceiro =
                  responseAuth.dadosIntegracao.codigoEmpresaParceiro
                localStorage.setItem('empresa', JSON.stringify(empresa))
                localStorage.setItem('ambiente', responseAuth.ambiente)
                localStorage.setItem('isLoginToken', true)
                localStorage.setItem(
                  'codigoOperadorDbs',
                  responseAuth.dadosIntegracao.operador.codigoOperador
                )
                th.$store.commit('onboarding/loginToken', true)
              } else {
                th.$api.UI.ShowError(
                  'Erro',
                  'Não foi possível renovar a sessão'
                )
                setTimeout(th.logout(), 3000)
              }
            })
            .then(() => {
              if (th.tempo <= 0) {
                setTimeout(function () {
                  th.startCountdown()
                }, 500)
              }

              const dataExpiracao = new Date(
                new Date().getTime() + responseAuth.expires * 60
              )
              const dataAtual = new Date()
              th.tempo = Math.trunc(
                (dataExpiracao.getTime() - dataAtual.getTime()) / 1000
              )

              const targetWindow =
                window.parent ?? window.top ?? window.opener ?? window
              targetWindow.postMessage('multiplo.sessaoRenovada', '*')
            })
        }
      } else {
        th.$api.UI.ShowError('Erro', 'Não foi possível renovar a sessão')
        setTimeout(th.logout(), 3000)
      }
    },
    refreshToken () {
      const th = this

      th.$api.Autenticacao.RefreshTokenRetaguardaOnboarding()
        .then(function (data) {
          th.handleRefreshSuccess(data)
        })
        .catch((err) => console.log(err))
    },
    getUserRole (jwtToken) {
      const jwtData = jwtToken.split('.')[1]
      const decodedJwtJsonData = window.atob(jwtData)
      return JSON.parse(decodedJwtJsonData).role
    },
    GetUserTokenRole (token) {
      try {
        var base64Url = token.split('.')[1]
        var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
        var jsonPayload = decodeURIComponent(
          window
            .atob(base64)
            .split('')
            .map(function (c) {
              return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
            })
            .join('')
        )
        return JSON.parse(jsonPayload).client_role
      } catch {
        const jwtData = token.split('.')[1]
        const decodedJwtJsonData = window.atob(jwtData)
        return JSON.parse(decodedJwtJsonData).client_role
      }
    },
  },
  computed: {
    portalBloqueado () {
      return localStorage.empresa
        ? JSON.parse(localStorage.empresa).portalIndicadorBloqueio
        : null
    },
  },
  async created () {
    const vm = this
    vm.$store.commit('onboarding/setParamNovoIb', await vm.$api.Dbs.GetParamIb());
    if (localStorage.status === 'loggedIn' && location.pathname) {
      const regex = /\/?authToken\/?/gm
      if (
        regex.test(location.pathname) &&
        location.search.indexOf('?token=') >= 0
      ) {
        localStorage.clear()
        localStorage.setItem('status', 'loggedOut')
        location.reload()
      }
      if (location.pathname.includes('partner') && localStorage.isLoginToken) {
        vm.$api.UTIL.Auth.Logout()
      }
    }
  },
  mounted () {
    if (localStorage.isLoginPadrao) {
      this.isLoginPadrao = true
    }
    if (localStorage.isLoginToken) {
      this.startInactiveTimer()
      this.handleSessionTime()
      this.isLoginToken = true
    }
  },
}
</script>
